export const LOGOUT_TIME = 2*7*24*60*60*1000;